import React from "react";
import OrthodoxArticles from "../../Components/Articles/OrthodoxArticles";

function ArticlesPage() {
    return (
        <OrthodoxArticles/>
    );
}

export default ArticlesPage;
